
import React, { InputHTMLAttributes } from 'react';

import { SInput } from '../../styles/components/Input';
import { validateField } from '../../utils/validateField';

type InputType = InputHTMLAttributes<HTMLInputElement>

const Input = ({...props }: InputType) => {

  const validate = (e: HTMLInputElement) => {
    const validation = validateField(e);
    validation();
  }

  return (
    <SInput
      {...props}
      onBlur={(e) => validate(e.currentTarget)}
      onSubmit={(e) => validate(e.currentTarget)}
    />
  );
}

export default Input;